/* eslint-disable @typescript-eslint/no-explicit-any */
export const emptyFn = (): any => undefined;
